module.exports = __webpack_public_path__ + "img/polar.80a829e.jpg";